import React ,{Component} from 'react';
import { NavLink,Navigate  } from 'react-router-dom';
import axios from 'axios';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody'; 
import SettingsIcon from '@mui/icons-material/Settings';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox'; 
import FormControlLabel from '@mui/material/FormControlLabel'; 
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import { blueGrey } from '@mui/material/colors';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Tooltip from '@mui/material/Tooltip';
import ReactToPrint from 'react-to-print';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import EmailTwoToneIcon  from '@mui/icons-material/EmailTwoTone';
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import DeleteIcon from '@mui/icons-material/Delete';
import Sendemail from './Sendemail';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import Columnsettings from './Columnsettings';
import logoImage from './images/logo.jpg';
import Dialog from '@mui/material/Dialog';      
import DialogActions from '@mui/material/DialogActions'; 
import DialogContent from '@mui/material/DialogContent'; 
import DialogTitle from '@mui/material/DialogTitle'; 
import psdfimage from './images/psdfimage.png';





const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}





export default class Purchasedaybook extends Component {
	
    constructor(props) {
    super(props);
	
	
	var strdob = new Date();
var month = "";

if ((strdob.getMonth() + 1) < 10) {
    month = "0" + (strdob.getMonth() + 1);
} else {
    month = (strdob.getMonth() + 1);
}

const currentDate = new Date();

var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();


	
 this.state = { 
 
 sestatus:'',isselectdisplay:false,open:false,todate1: currentDate.getFullYear() + '-' + month1 + '-' + lastDay, todate:lastDayOfMonth ,
fromdate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),openExportDialog: false, 
 fromdate1:currentDate.getFullYear() + '-' + month1 + '-' + '01',vendorbookData:[],type:0,businessname:'',
redirect:false,pagename:'' ,id:'',page:0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],quotenumber:'',contactname:'',
search:'',order:'desc' ,orderBy:'sin_id',iconslist:false,allchecked:false,totaldata:0,reportData:[], 
	  
		
		
	}  
  this.ondateChangeHandler = this.ondateChangeHandler.bind(this);	
	}
	
 myChangeHandler = (event) => {
	
  let nam = event.target.name;
  let val = event.target.value;
  
 
  
  this.setState({[nam]: val});
  

 } 


componentWillMount() {
	document.title = "Isifol - Purchase Day Report";

  if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
		if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {	
  this.apicall(this.state.page,this.state.rowsPerPage); 	  
		  }
		  else{	    
		this.PageAccessCheckApi();
         }
}
		  
		   this.props.parentdasCallback(
            "Purchase Day Report~"
        );
		 



}
PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=32')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
  this.apicall(this.state.page,this.state.rowsPerPage); 
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}

apicall(page,rowsPerPage){
	
	
	axios.get(localStorage.getItem("ISIurl")+'ajaxvendorbill.php?action=reportgetall&StartIndex='+page+'&PageSize='+rowsPerPage+'&fromdate=' +this.state.fromdate1+'&todate='+this.state.todate1+ '&vb_type='+this.state.type+'&ve_businessname='+this.state.quotenumber+'&vb_cmp_id='+localStorage.getItem('ISIcmpid'))
   
	  .then(resp => {  	
		if(resp.data.length>0){
			let copy=[50, 100, 150, 200, 250];
				this.setState({  
				  vendorbookData: resp.data,

					
				   totaldata:parseInt(resp.data[0].count),
				   rowsPaging:[],rowsPaging:copy	
				});

		 }
	 
		  else
		  
		  {
			   this.setState({vendorbookData:[],totaldata:0});
		  }
	 
  
    });
	this.printarray();
}

printarray(){
	
	
	axios.get(localStorage.getItem("ISIurl")+'ajaxvendorbill.php?action=reportgetall&vb_cmp_id='+localStorage.getItem('ISIcmpid'))
     
  .then(resp => {  	
    if(resp.data.length>0){
			this.setState({  
			  reportData: resp.data,
			  
			});

     }
	 
	  else{
		   this.setState({reportData:[]});
	 }
	 
  
    });
}

  Handleclickviewmore= (e) =>{
	  
	  this.setState({isselectdisplay:true});
	  
  }



ondateChangeHandler = (value) => {

}

updateDateRange = (startDate, endDate) => {
  this.setState({
    fromdate: startDate,
    todate: endDate,
    fromdate1: startDate.format('YYYY-MM-DD'),
    todate1: endDate.format('YYYY-MM-DD')
  });
}


    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };

handleClickSearch=()=>{
 this.apicall(this.state.page,this.state.rowsPerPage); 
}
onchangedateHandler = (event) => {
  let selectedOption = event.target.value;
  const periodMap = {
    'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
   'This Quarter': [dayjs().startOf('month'), dayjs().endOf('month').add(3, 'month')],
    'This Year': [dayjs().startOf('year'), dayjs().endOf('year')],
    'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
    'Last Quarter': [dayjs().endOf('month'), dayjs().startOf('month').subtract(3, 'month')],
    'Last Year': [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
	 'This Financial Year': [dayjs().startOf('Year').add(3, 'month'), dayjs().endOf('Year').add(3, 'month')],
	 'Last Financial Year': [dayjs().subtract(1, 'year').subtract(8, 'month'), dayjs().startOf('Year').add(2, 'month')],
    'Custom':[dayjs(), dayjs().endOf('month')]
  };

if (selectedOption === 'Custom') {
    this.setState({
      fromdate: periodMap['Custom'][0],
      todate: periodMap['Custom'][1],
      fromdate1: periodMap['Custom'][0].format('YYYY-MM-DD'),
      todate1: periodMap['Custom'][1].format('YYYY-MM-DD'),
      fromDateEnabled: true,
      toDateEnabled: true
    });
  } else {
    this.setState({
      fromdate: periodMap[selectedOption][0],
      todate: periodMap[selectedOption][1],
      fromdate1: periodMap[selectedOption][0].format('YYYY-MM-DD'),
      todate1: periodMap[selectedOption][1].format('YYYY-MM-DD'),
      fromDateEnabled: false,
      toDateEnabled: false
    });
  }
};


handleChangePage = (event, newPage) => {  

   
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  }; 
   
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
 
  
  


  
  
  todatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);
	
 this.setState({
    todate: dayjs(dateObj),
    todate1: dateObj.getFullYear() + '-' + (dateObj.getMonth() + 1) + '-' + dateObj.getDate(),
    toDateEnabled: true
  });
 

  }
		
		


  CloseMoreoption = (date) =>{
	
	this.setState({isselectdisplay:false});
}

	
 handleDownload = () => {
        const { vendorbookData } = this.state;
        const doc = new jsPDF();

 const imgWidth = 40;  
    const imgHeight = 12; 
    const imgX = (doc.internal.pageSize.width - imgWidth) / 2; 
    const imgY = 10;      
doc.addImage(logoImage, 'JPEG', imgX, imgY, imgWidth, imgHeight);

 
    const title = 'Trial Balance Report';
    doc.setFontSize(16);

  
    const titleY = imgY + imgHeight + 8;

    doc.text(title, doc.internal.pageSize.width / 2, titleY, { align: 'center' });
	const tableStartY = titleY + 10; 


        const headers = [
            [ 'Type', 'Date', 'Name', 'Invoice Number', 'Reference', 'Details','Total' ]
        ];

 const rows = [];

         vendorbookData.forEach(item => {
            let strlink = "";
            let strtype = "";

            if(item.type==="0") {
                strtype="All";
            } else if(item.type==="1") {
                strtype="Vendor bill";
                strlink="#/vendorbillviewmore?vbid=";
            } else if(item.type==="2") {
                strtype="Vendorbill Credit Notes";
                strlink="#/Vendorcreditnoteviewmore?vcnid=";
            }
           rows.push([
                
                strtype,
                item.billdate,
                item.ve_contactname,
                item.vb_vendorbillno,
                item.ve_referenceno,
                '',
                item.vbp_total,
            ]);
        });
		
        doc.autoTable({
            head: headers,
            body: rows,
            startY: 20,
            theme: 'striped',
            didDrawPage: function (data) {
                var str = "Page " + doc.internal.getNumberOfPages()
                doc.setFontSize(10)
                doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10)
            }
        });

        doc.save('PurchasedaybookReport.pdf');
    };

	

	  
	render()
	{
		
		const { checkedvalues } = this.state;
		return(
		   <React.Fragment>

<div className="searchbox">

<ul>


 <li>
        <p>Search</p>
        <p>
          <TextField
            variant="outlined"
            fullWidth
			className="txtbox"
            value={this.state.quotenumber}
            id="quotenumber"
            inputProps={{ tabIndex: "1", maxLength: 150 }}
            name="quotenumber"
            onChange={this.myChangeHandler}
            InputProps={{
              endAdornment: (
                <SearchOutlinedIcon style={{ marginLeft: 8 }} />
              ),
            }}
          />
        </p>
      </li>
		  

<li>
<p>Period</p> <p><Select
  native
  variant="outlined" className="txtbox"
  margin="normal"
  fullWidth 
  onChange={this.onchangedateHandler}
  inputProps={{tabIndex: "4"}}
        > <option>This Month</option>
          <option>This Quarter</option>
          <option>This Year</option>
          <option>Last Month</option>
          <option>Last Quarter</option>
          <option>Last Year</option>
          <option>This Financial Year</option>
          <option>Last Financial Year</option>
          <option>Custom</option>
  </Select></p>


</li>

	
<li>

<p><p>From Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={['DatePicker']}>
    <DatePicker
      disabled={!this.state.fromDateEnabled}
      value={dayjs(this.state.fromdate)}
      className="txtbox"
      onChange={this.fromdatehandler}
      format="MM/DD/YYYY"
    />
  </DemoContainer>
</LocalizationProvider></p>

</li>


<li>


<p><p>To Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={['DatePicker']}>
    <DatePicker
      disabled={!this.state.toDateEnabled}
      value={dayjs(this.state.todate)}
      className="txtbox"
      onChange={this.todatehandler}
      format="MM/DD/YYYY"
    />
  </DemoContainer>
</LocalizationProvider></p></li>
	
	
	
	
<li>
<p>&nbsp;</p>
<p>
<Button
type="submit"
variant="outlined" 
className="morebtn"
onClick={this.Handleclickviewmore}
          
          >
            More
          </Button>
		  
  <span className="closeincon">
   {this.state.isselectdisplay === true && (
      <CloseRoundedIcon onClick={this.CloseMoreoption} />
    )}
   </span>
		  
		  
</p>
</li>
	

	
<li>
<p>&nbsp;</p>
	 <p className="searchbutton">
       <Button
  type="submit"
  variant="contained"
  className="frmSecondarybtn"
  onClick={this.handleClickSearch}
>
 
  Calculate 
</Button>







        &nbsp;
		
		                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="exportbtn"
                                    onClick={this.handleOpenExportDialog} 
                                >
                                    EXPORT
                                </Button>
   
      </p>
		
				
		</li>
		
		

	{this.state.isselectdisplay===true &&(
<li>
<p>Type</p> <p><Select
  native
  variant="outlined" className="txtbox"
  margin="normal"
  fullWidth 
  onChange={this.myChangeHandler}
  id="type"
  value={this.state.type}
  name="type"
  inputProps={{tabIndex: "4"}}
        ><option value={0}>All</option>
	<option value={1}>Vendor Bill</option>
	<option value={2}>Vendor Credit Note</option>
		
  </Select></p>


</li>	

	)}

</ul>

</div>	
		
	
		
	<div className="clear"></div>

	
		
<div className="estimatebox">
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container}>  
<Table stickyHeader aria-label="sticky table" id="salesbook"> 
 <TableHead>
          <TableRow>
		  	<TableCell>Type </TableCell>	
		    <TableCell> Date</TableCell>	
            <TableCell>Name</TableCell>	
            <TableCell> Invoice Number</TableCell>		
		    <TableCell>Reference </TableCell>	
            <TableCell>Details </TableCell>
			<TableCell>Total </TableCell>		
			
			
			
			
			  
          </TableRow>
        </TableHead>

 

  <TableBody>
  

 {stableSort(this.state.vendorbookData, getSorting(this.state.orderBy, this.state.order)).map((item,index) => {  



 const typeStr = String(item.type);
    const id = item.vb_id || item.vb_id; 


  let strlink = '';

    if (typeStr === '1') {
      strlink = `#/vendorbillviewmore?vbid=${id}`;
    } else if (typeStr === '2') {
      strlink = `#/Vendorcreditnoteviewmore?vcnid=${id}`;
    }
   const getTypeString = (type) => {
      switch (type) {
        case '0':
          return 'All';
        case '1':
          return 'Vendotr Bill';
        case '2':
          return 'Vendor Credit Note';
        case '3':
          return 'Vendor QE Credit';
        case '4':
          return 'Vendor QE Bill';
        case '5':
          return 'Vendor OB Credit';
        case '6':
          return 'Vendor OB Invoice';
        default:
          return '';
      }
    };


           return (
 <React.Fragment>
 
 
 <TableRow
          style={{ cursor: strlink ? 'pointer' : 'default' }}
          onClick={() => { if (strlink) window.location.href = strlink; }}
        >
 
<TableCell>{getTypeString(item.type)}</TableCell>
<TableCell>{item.billdate}</TableCell>
<TableCell>{item.ve_contactname}</TableCell>
<TableCell>{item.vb_vendorbillno}</TableCell>
<TableCell>{item.ve_referenceno}</TableCell>
<TableCell>{item.ve_referenceno} </TableCell>
<TableCell> {'\u200B' + parseFloat(item.vbp_total || 0).toFixed(2)}</TableCell>
</TableRow>


				</React.Fragment>	
				);
					})}
					 

					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan={8}>No Records</TableCell>
					</TableRow>
					) }
					
			 {this.state.vendorbookData.length > 0 && (
                    <TableRow>
                        <TableCell colSpan={6} align="right"><b>Total:</b></TableCell>
                      
                        <TableCell>
    <b>
        $
        {'\u200B' + parseFloat(
            this.state.vendorbookData.reduce(
                (sum, item) => sum + parseFloat(item.vbp_total || 0),
                0
            )
        ).toFixed(2)}
    </b>
</TableCell>
                    </TableRow>
                )}		
					
 </TableBody>


	   
</Table>
  </TableContainer> 
  <TablePagination  
           rowsPerPageOptions={[50, 100, 150,200]} 
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />    
  </Paper>
   
 </div>



      <Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
                    <DialogTitle>Generated Detailed Trial Balance report</DialogTitle>
					
                    <DialogContent>
					<p> To generate a new report, based on the latest selection criteria you've specified, choose the format 
					you want to use. Depending on the amount of data included on the report, it may take some time to generate.</p>
                        
				<p style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "20px" }}>
				 <ReactHTMLTableToExcel
				  variant="contained"
				  color="primary"
				  id="test-table-xls-button"
				   className="my-custom-excel-button" 
				  table="salesbook"
				  filename="Sales Day Book Report"
				  sheet="Sales Day Book Report"
				  buttonText=""
				  
				 /> 
                    <img
						src={psdfimage}
						width={100}
						height={100}
						style={{ cursor: "pointer" }}
						onClick={this.handleDownload}
						alt="Download PDF"
					 />
											
						</p>
						
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseExportDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>





  
	   </React.Fragment>	
		
		)
			
		
	}
	
	
}

   export class fromtodate extends Component {
  constructor(props) {
    super(props);
    this.state = {
		   fromdate: props.fromdate || new Date(),
      todate: props.todate || new Date(),
      fromdate1: props.fromdate1 || '',
      todate1: props.todate1 || '',
    };
  }

onchangedateHandler = (event) => {
  let selectedOption = event.target.value;
  const periodMap = {
    'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
   'This Quarter': [dayjs().startOf('month'), dayjs().endOf('month').add(3, 'month')],
    'This Year': [dayjs().startOf('year'), dayjs().endOf('year')],
    'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
    'Last Quarter': [dayjs().endOf('month'), dayjs().startOf('month').subtract(3, 'month')],
    'Last Year': [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
	 'This Financial Year': [dayjs().startOf('Year').add(3, 'month'), dayjs().endOf('Year').add(3, 'month')],
	 'Last Financial Year': [dayjs().subtract(1, 'year').subtract(8, 'month'), dayjs().startOf('Year').add(2, 'month')],
    'Custom':[dayjs(), dayjs().endOf('month')]
  };

if (selectedOption === 'Custom') {
    this.setState({
      fromdate: periodMap['Custom'][0],
      todate: periodMap['Custom'][1],
      fromdate1: periodMap['Custom'][0].format('YYYY-MM-DD'),
      todate1: periodMap['Custom'][1].format('YYYY-MM-DD'),
      fromDateEnabled: true,
      toDateEnabled: true
    });
  } else {
    this.setState({
      fromdate: periodMap[selectedOption][0],
      todate: periodMap[selectedOption][1],
      fromdate1: periodMap[selectedOption][0].format('YYYY-MM-DD'),
      todate1: periodMap[selectedOption][1].format('YYYY-MM-DD'),
      fromDateEnabled: false,
      toDateEnabled: false
    });
  }
};


  
  
  todatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);
	
 this.setState({
    todate: dayjs(dateObj),
    todate1: dateObj.getFullYear() + '-' + (dateObj.getMonth() + 1) + '-' + dateObj.getDate(),
    toDateEnabled: true
  });
 

  }
  


  render() {
 return (
	
	 <React.Fragment>
	 <div className="searchbox">

<ul>

<li>
<p>Period</p> <p><Select
  native
  variant="outlined" className="txtbox"
  margin="normal"
  fullWidth 
  onChange={this.onchangedateHandler}
  inputProps={{tabIndex: "4"}}
        > <option>This Month</option>
          <option>This Quarter</option>
          <option>This Year</option>
          <option>Last Month</option>
          <option>Last Quarter</option>
          <option>Last Year</option>
          <option>This Financial Year</option>
          <option>Last Financial Year</option>
          <option>Custom</option>
  </Select></p>


</li>

	
<li>

<p><p>From Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={['DatePicker']}>
    <DatePicker
      disabled={!this.state.fromDateEnabled}
      value={dayjs(this.state.fromdate)}
      className="txtbox"
      onChange={this.fromdatehandler}
      format="MM/DD/YYYY"
    />
  </DemoContainer>
</LocalizationProvider></p>

</li>


<li>


<p><p>To Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={['DatePicker']}>
    <DatePicker
      disabled={!this.state.toDateEnabled}
      value={dayjs(this.state.todate)}
      className="txtbox"
      onChange={this.todatehandler}
      format="MM/DD/YYYY"
    />
  </DemoContainer>
</LocalizationProvider></p></li>
	
	
	</ul>
	</div>
	 </React.Fragment>

  )}
   }